import React from 'react';

const CardTitle = props => <span className="card-title" {...props} />;

export default CardTitle;
